import React from 'react';
import { useMediaQuery } from 'hooks';
import { sad } from 'static/icons/resizable';
import { Icon } from 'view/atoms';
import { NoContentProps } from './NoContent.model';
import * as S from './NoContent.styles';

export const NoContent = ({ title, description, children }: NoContentProps) => {
  const { mobile, tablet } = useMediaQuery();

  const isMobile = mobile || tablet;

  return (
    <S.ContentBox>
      <Icon src={sad} />

      <S.Title kind={isMobile ? 'h1' : 'h2'} color='gray1'>
        {title}
      </S.Title>

      <S.Description kind='body' color='gray1'>
        {description}
      </S.Description>

      {children}
    </S.ContentBox>
  );
};
